import styled from 'styled-components';

export const StepCard = styled.div`
  max-width: 680px;
`;

export const StepsList = styled.ol`
  display: flex;
  gap: 1.5rem;
  list-style: none;
  padding: 0;
  margin: 0 0 1.5rem;
  flex-wrap: wrap;
`;

export const StepItem = styled.li`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: ${(props) => (props.isActive ? '#282828' : '#9e9e9e')};
  font-weight: ${(props) => (props.isActive ? 700 : 400)};
`;

export const StepNumber = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-size: 0.8rem;
  color: #fff;
  background-color: ${(props) => (props.isCurrentOrDone ? '#FF7417' : '#c7c7c7')};
`;

export const ActionsRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1.5rem;
`;
